/**
 * Takes an element id and scrolls to it if the element is not visible
 * @param id Id of the element
 * @param timeout Timeout before scroll happens. Defaults to 200.
 * @param block Where on the element should the scroll stop. Defaults to "start".
 * @param alwaysScroll Scroll even if the element is visible. Defaults to false.
 */

// TODO Update to also take a ref
export const scrollToElement = (
    id: string,
    timeout = 200,
    block: ScrollLogicalPosition = "start",
    alwaysScroll = false
) => {
    setTimeout(() => {
        const element = document.querySelector(`#${id}`);

        // let element = document.querySelector(`#${id}`);

        // if (ref) {
        //     element = ref.current
        // }

        if (!element) {
            return;
        }

        const elementClientRect = element.getBoundingClientRect();

        // Only scroll...
        if (
            alwaysScroll || // ... if alwaysScroll is true
            elementClientRect.top > window.innerHeight || // ... or if top of element is below the window
            elementClientRect.bottom < 0 // ... or if bottom of element is above the window
        ) {
            element.scrollIntoView({ behavior: "smooth", block: block });
        }
    }, timeout);
};
